export class ExceededSlaTimeModel {
  quantityPendingCredit: number;
  quantityManualAnalysis: number;
}
